import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Wrap = styled.div`
    min-width: 0;
`;

export const Value = styled.div`
    margin-bottom: 4px;
`;

export const Track = styled.div`
    height: 8px;
    border-radius: ${radii.small};
    background: ${colors.segmentBg};
    overflow: hidden;
`;

export const Fill = styled.div<{ $percent: number }>`
    height: 100%;
    width: ${(props) => props.$percent}%;
    background: ${colors.primary};
`;
